export const users = {
    "demo3-Default_Access": {
        "heroSectionSubText": "",
        "trustedSectionTitle": "Your trusted",
        "trustedSectionSecTitle": "Partner",
        "trustedSectionSubText": "",
    },
    "demo3-Default_Access_Conference": {
        "heroSectionSubText": "Helping healthcare leaders achieve their goals",
        "trustedSectionTitle": "The trusted",
        "trustedSectionSecTitle": "Partner of Choice",
        "trustedSectionSubText": "Certilytics innovative approaches are helping leading healthcare organizations leverage predictive insights to identify the largest opportunities for better value-based care.",
    }
}